import { Card, Heading, Link } from '@digdir/designsystemet-react';
import './imageTextBox.css';
import React from 'react';
import { ImageData } from './../CommonTypes';
import { RichText } from '@enonic/react-components';

interface ImageTextBoxType {
	title: string;
	text: TextAndImageBoxText;
	url: string;
	imageData: ImageData;
}

interface TextAndImageBoxText {
	processedHtml: string;
	macros: any[];
	images: any[];
	links: any[];
	macroComponents: any[];
}

export const ImageTextBox = ({
	props,
	index,
}: {
	props: ImageTextBoxType;
	index: number;
}) => {
	return (
		<>
			<img src={props.imageData.url} alt={props.imageData.altText} />

			<Card data-color={index % 2 === 0 ? 'main2' : 'default'}>
				<Card.Block>
					{props.title && (
						<Heading level={3}>
							{props.url ? (
								<Link href={props.url}>{props.title}</Link>
							) : (
								props.title
							)}
						</Heading>
					)}

					{props.text && <RichText data={props.text} />}
				</Card.Block>
			</Card>
		</>
	);
};
